import {
  IonIcon,
  IonItem,
  IonItemOption,
  IonItemOptions,
  IonItemSliding,
} from "@ionic/react";
import { notificationsOutline, trashBinOutline } from "ionicons/icons";
import React, { memo, useContext, useEffect, useRef, useState } from "react";
import { RouteProps } from "react-router";
import { v4 as uuidv4 } from "uuid";
import config from "../../../components/helpers/socket/config";
import { hapticsImpactMedium } from "../../../utils/core-utils/hapticUtils";
import firebaseEventConfig from "../../../utils/firebaseAnalytics/firebaseEventConfig";
import { CMEDfirebaseLogEvent } from "../../../utils/firebaseAnalytics/firebaseUtils";
import { send } from "../../../utils/sockets/asyncSocket";
import { CMEDPermissions } from "./MarketDataContent";
import MarketDataOverviewModal from "./MarketDataOverviewModal";
import { useAppPref } from "../../../components/providers/AppPrefProvider";
import PriceAlertModal from "./PriceAlertModal";
import BeaconAccessContext from "../../../components/contexts/BeaconAccessContext";

interface NewMarketDataListItemProps extends RouteProps {
  tradingGridGroupData: Data;
  userCMEDEntitlements: CMEDPermissions | undefined;
  currentTradingGridGroup: number | undefined;
  itemIndex: number;
  setOpenOrderEntryModal: any;
  setOrderEntryType: any;
  setOrderEntryData: any;
  OpenOrderEntryModal: any;
  OrderEntryType: any;
  selectedOrderAgressionItem: any;
  orderAggression: any;
  setorderAggression: any;
  // setopenOrderAggressionModal: any;
  setOrderEntryData_Live: any;
  orderEntryData: any;
  orderEntryData_Live: any;
}

type Data = {
  b: { r: number; f: string };
  bb: { r: number; f: string };
  bo: { r: number; f: string };
  boq: { r: number; f: string };
  c: string;
  i: boolean;
  id: string;
  ii: number;
  l: any;
  lt: number;
  n: any;
  s: number;
  t: any;
  ts: string;
  wo: number;
  g: string;
  gi: string;
};

const NewMarketDataListItem: React.FC<NewMarketDataListItemProps> = ({
  tradingGridGroupData,
  currentTradingGridGroup,
  setOpenOrderEntryModal,
  setOrderEntryType,
  setOrderEntryData,
  setOrderEntryData_Live,
  orderEntryData,
  userCMEDEntitlements,
  orderEntryData_Live,
}) => {
  const [isMarketDataOverviewModalOpen, setIsMarketDataOverviewModalOpen] =
    useState<boolean>(false);
  const { setIsOrderEntryOpenedFromMain } = useAppPref();
  const [isPriceAlertModalOpen, setIsPriceAlertModalOpen] =
    useState<boolean>(false);
  const [alertModalTradingData, setAlertModalTradingData] =
    useState<Data | null>(null);
  const { hasBeaconAccess } = useContext(BeaconAccessContext);
  const slidingItemRef = useRef<HTMLIonItemSlidingElement>(null);

  useEffect(() => {
    if (orderEntryData?.ii === tradingGridGroupData?.ii) {
      setOrderEntryData_Live(tradingGridGroupData);
    }
  }, [tradingGridGroupData]);

  function removeContractFromGrid() {
    const request = {
      action: config.socket.actions.CMED_REMOVE_CONTRACTS,
      requestID: uuidv4(),
      type: "notUsedButMustBePresentForLegacyValidation",
      payload: {
        itemId: tradingGridGroupData?.id,
        groupId: currentTradingGridGroup,
      },
    };

    send(config.socket.channels.TRADING, request);

    CMEDfirebaseLogEvent(
      firebaseEventConfig.CMEDComponentNames.CMED_MARKET_DATA,
      firebaseEventConfig.eventNames.CMED_MARKET_DATA
        .CMED_MARKET_DATA_REMOVE_CONTRACT,
    );
  }

  function splitSentence(sentence: string): [string, string] {
    // Find the index of the first space
    const firstSpaceIndex = sentence.indexOf(" ");
    // If a space is found, split the sentence
    if (firstSpaceIndex !== -1) {
      const firstPart = sentence.substring(0, firstSpaceIndex);
      const secondPart = sentence.substring(firstSpaceIndex + 1);
      return [firstPart, secondPart];
    } else {
      // If no space is found, the whole sentence is the first part, and the second is empty
      return [sentence, ""];
    }
  }

  return (
    <>
      <IonItemSliding ref={slidingItemRef}>
        <IonItem
          button
          detail={false}
          className="ion-no-padding animate__animated animate__fadeIn animate__faster"
          lines="none"
          style={{
            "--inner-padding-end": 0,
            "--min-height": "70px",
            "--background": "#112B4A",
            marginBottom: "2px",
          }}
        >
          <div className="custom_marketdata_item">
            <div className="custom_marketdata_item_child">
              <div
                className="contract_volume_last_change_section"
                onClick={() => {
                  console.log("market data overview modal open");
                  hapticsImpactMedium();
                  setIsMarketDataOverviewModalOpen(true);
                  setOrderEntryData(tradingGridGroupData);
                  setOrderEntryData_Live(tradingGridGroupData);
                  CMEDfirebaseLogEvent(
                    firebaseEventConfig.CMEDComponentNames.CMED_MARKET_DATA,
                    firebaseEventConfig.eventNames.CMED_MARKET_DATA
                      .CMED_MARKET_DATA_VIEW_CONTRACT,
                  );
                }}
              >
                <div className="contract_name_sub_section">
                  {((tradingGridGroupData?.bb?.r !== undefined &&
                    tradingGridGroupData?.bb?.r !== 0) ||
                    (tradingGridGroupData?.bo?.r !== undefined &&
                      tradingGridGroupData?.bo?.r !== 0)) &&
                    tradingGridGroupData?.wo !== 0 && (
                      <div className="contract_name_sub_section_child_1"></div>
                    )}
                  <div className="contract_name_sub_section_child_2">
                    {splitSentence(tradingGridGroupData?.c)[0]}
                  </div>
                  <div className="contract_name_sub_section_child_3">
                    {splitSentence(tradingGridGroupData?.c)[1]}
                  </div>
                </div>
                <div className="last_change_volume_sub_section">
                  <div className="last">
                    {tradingGridGroupData?.l?.f || "\u200B"}
                  </div>
                  <div
                    className={`change ${
                      tradingGridGroupData?.n?.r < 0 && "change_negative"
                    } ${tradingGridGroupData?.n?.r > 0 && "change_positive"}`}
                  >
                    {tradingGridGroupData?.n?.r > 0 ? "+" : ""}
                    {tradingGridGroupData?.n?.f || "\u200B"}
                  </div>
                  <div className="volume">
                    {tradingGridGroupData?.t?.f || "\u200B"}
                  </div>
                </div>
              </div>
              <div
                className="bid_qty_section"
                onClick={() => {
                  console.log("bid");
                  hapticsImpactMedium();
                  userCMEDEntitlements?.agressiveOrderIndicator === true
                    ? setOrderEntryType("offer")
                    : setOrderEntryType("bid");
                  setIsOrderEntryOpenedFromMain(true);
                  setOpenOrderEntryModal(true);
                  setOrderEntryData(tradingGridGroupData);
                  setOrderEntryData_Live(tradingGridGroupData);
                }}
              >
                <div className="bid_price">
                  {tradingGridGroupData?.bb?.r !== 0 ||
                  tradingGridGroupData?.b?.r !== 0
                    ? tradingGridGroupData?.bb?.f
                    : "\u200B"}
                </div>
                <div
                  className="bid_price_qty"
                  style={
                    tradingGridGroupData?.b?.r !== 0
                      ? {}
                      : { visibility: "hidden" }
                  }
                >
                  {tradingGridGroupData?.b?.f || "\u200B"}
                </div>
              </div>
              <div
                className="offer_qty_section"
                onClick={() => {
                  hapticsImpactMedium();
                  console.log("offer");
                  setOpenOrderEntryModal(true);
                  userCMEDEntitlements?.agressiveOrderIndicator === true
                    ? setOrderEntryType("bid")
                    : setOrderEntryType("offer");
                  setIsOrderEntryOpenedFromMain(true);
                  setOrderEntryData(tradingGridGroupData);
                  setOrderEntryData_Live(tradingGridGroupData);
                }}
              >
                <div className="offer_price">
                  {tradingGridGroupData?.bo?.r !== 0 ||
                  tradingGridGroupData?.boq?.r !== 0
                    ? tradingGridGroupData?.bo?.f
                    : "\u200B"}
                </div>
                <div
                  className="offer_price_qty"
                  style={
                    tradingGridGroupData?.boq?.r !== 0
                      ? {}
                      : { visibility: "hidden" }
                  }
                >
                  {tradingGridGroupData?.boq?.f || "\u200B"}
                </div>
              </div>
            </div>
          </div>
        </IonItem>
        <IonItemOptions>
          <IonItemOption
            color="danger"
            onClick={() => {
              removeContractFromGrid();
              hapticsImpactMedium();
            }}
          >
            <IonIcon slot="icon-only" icon={trashBinOutline}></IonIcon>
          </IonItemOption>
          {hasBeaconAccess && (
            <IonItemOption
              color="secondary"
              onClick={() => {
                hapticsImpactMedium();
                setIsPriceAlertModalOpen(true);
                setAlertModalTradingData(tradingGridGroupData);
                slidingItemRef.current?.close();
              }}
            >
              <IonIcon slot="icon-only" icon={notificationsOutline}></IonIcon>
            </IonItemOption>
          )}
        </IonItemOptions>
      </IonItemSliding>
      <MarketDataOverviewModal
        isMarketDataOverviewModalOpen={isMarketDataOverviewModalOpen}
        setIsMarketDataOverviewModalOpen={setIsMarketDataOverviewModalOpen}
        setOpenOrderEntryModal={setOpenOrderEntryModal}
        setOrderEntryType={setOrderEntryType}
        setOrderEntryData={setOrderEntryData}
        tradingGridGroupData={tradingGridGroupData}
        orderEntryData_Live={orderEntryData_Live}
        setOrderEntryData_Live={setOrderEntryData_Live}
      />
      {isPriceAlertModalOpen && alertModalTradingData && hasBeaconAccess && (
        <PriceAlertModal
          isOpen={isPriceAlertModalOpen}
          onDidDismiss={() => {
            setIsPriceAlertModalOpen(false);
            setAlertModalTradingData(null);
          }}
          tradingGridGroupData={
            isPriceAlertModalOpen ? alertModalTradingData : null
          }
        />
      )}
    </>
  );
};

export default memo(NewMarketDataListItem);
